import { useSidePanelCloseListener } from "./side-panel-close-listener.hook";

const SidePanelCloseListener = () => {
  useSidePanelCloseListener();

  return null;
};

export default SidePanelCloseListener;
